var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SwiperCarousel",
    {
      attrs: {
        name: "tour-hotel-carousel",
        speed: 1000,
        autoplayDelay: 5000,
        loop: true,
        freeMode: true,
        slidesPerViewMobile: 1,
        slidesPerViewTablet: 1,
        slidesPerViewDesktop: 1,
        slidesPerViewLargeDesktop: 1,
        "show-navigation": true,
        "show-pagination": true,
      },
    },
    _vm._l(_vm.hotels, function (hotel, index) {
      return _c("div", { key: index, staticClass: "swiper-slide" }, [
        _c("picture", [
          _c("img", {
            attrs: {
              src: hotel.imageUrl,
              alt: hotel.imageAltTagText,
              loading: "lazy",
            },
          }),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }